module.exports = __webpack_public_path__ + "media/components/wind-icon/static/WNW@2x-a6ce4c2f0c67217e1f360aab2b3a4eba.png";